<template>
    <div>
        <!-- Begin:PageContent -->
        <section id="content">
            <div class="container">
                <div class="row">
                    <!-- Begin:PagePrivacy -->
                    <div id="main" class="col-md-9">
                        <div class="container shortcode travel-ideas">
                            <h1 class="idea-title"><span class="index"><i class="soap-icon-star circle"></i></span>{{ titleinfo[getCurrentLocale] }}</h1>
                        </div>
                        <br />

                        <div class="booking-information sdr-box">
                            <h4 v-html="luggage_h4[getCurrentLocale]"></h4>
                            <h5 v-html="luggage_h5[getCurrentLocale]"></h5>
                            <p v-html="luggage_p_1[getCurrentLocale]"></p>


                            <br /><h5 v-html="luggage_h5_2[getCurrentLocale]"></h5>
                            <p v-html="luggage_p_2[getCurrentLocale]"></p>


                            <br /><h5 v-html="luggage_h5_3[getCurrentLocale]"></h5>
                            <p v-html="luggage_p_3[getCurrentLocale]"></p>
                            <p v-html="luggage_p_4[getCurrentLocale]"></p>
                            <ul class="check-circle box" style="margin-bottom: 10px; margin-left: 15px;">
                                <li v-html="luggage_li_1[getCurrentLocale]"></li>
                                <li v-html="luggage_li_2[getCurrentLocale]"></li>
                                <li v-html="luggage_li_3[getCurrentLocale]"></li>
                            </ul>
                            <br /><p v-html="luggage_p_5[getCurrentLocale]"></p>


                            <br /><p v-html="luggage_p_6[getCurrentLocale]"></p>
                            <ul class="check-circle box" style="margin-bottom: 10px; margin-left: 15px;">
                                <li v-html="luggage_li_4[getCurrentLocale]"></li>
                                <li v-html="luggage_li_5[getCurrentLocale]"></li>
                                <li v-html="luggage_li_6[getCurrentLocale]"></li>
                            </ul>


                            <br/><p v-html="luggage_p_7[getCurrentLocale]"></p>
                            <p v-html="luggage_p_8[getCurrentLocale]"></p>


                            <br /><h5 v-html="luggage_h5_4[getCurrentLocale]"></h5>
                            <p v-html="luggage_p_9[getCurrentLocale]"></p>
                            <p v-html="luggage_p_10[getCurrentLocale]"></p>
                            <ul class="check-circle box" style="margin-bottom: 10px; margin-left: 15px;">
                                <li v-html="luggage_li_7[getCurrentLocale]"></li>
                                <li v-html="luggage_li_8[getCurrentLocale]"></li>
                                <li v-html="luggage_li_9[getCurrentLocale]"></li>
                                <li v-html="luggage_li_10[getCurrentLocale]"></li>
                                <li v-html="luggage_li_11[getCurrentLocale]"></li>
                                <li v-html="luggage_li_12[getCurrentLocale]"></li>
                                <li v-html="luggage_li_13[getCurrentLocale]"></li>
                            </ul>


                            <br /><p v-html="luggage_p_11[getCurrentLocale]"></p>
                            <br /><p>Update: 27.01.2021</p>
                        </div>
                    </div>
                    <!-- End:PagePrivacy -->

                    <!-- Begin:Content-SideBar -->
                    <div class="sidebar col-md-3">
                        <sdr-aboutsundair-box></sdr-aboutsundair-box>
                        <sdr-contact-box></sdr-contact-box>
                    </div>
                    <!-- END:Content-SideBar -->
                </div>
            </div>
        </section>
        <!-- End:PageContent -->


        <!-- Begin:PromoBox -->
        <sdr-promobox></sdr-promobox>
        <!-- End:PromoBox -->
    </div>
</template>

<script>
    import AboutSundairBox from '../../shared/sidebar/AboutSundairBox.vue'; // Sidebar (right)
    import ContactBox from '../../shared/sidebar/ContactBox.vue'; // Sidebar (right)
    import PromoBox from '../../booking/pagecontent/PromoBox.vue';

    import { mapGetters } from 'vuex';


    export default {

        /* >>> *************************************************************** / /* Components */
        components: {

            'sdr-aboutsundair-box': AboutSundairBox,
            'sdr-contact-box': ContactBox,
            'sdr-promobox': PromoBox,

        }, // eof components{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data: function() {

            return {
                titleinfo: {
                    en: 'Information on baggage transport',
                    de: 'Informationen zur Gepäckbeförderung',
                },
                // >>> ------------------------
                luggage_h4 : {
                    en: 'Information about Baggage Transportation',
                    de: 'Informationen zur Gepäckbeförderung',
                },
                luggage_h5 : {
                    en: 'Baggage',
                    de: 'Reisegepäck',
                },
                luggage_p_1 : {
                    en: 'Baggage comprises carry-on baggage and checked baggage.',
                    de: 'Ihr Reisegepäck umfasst Handgepäck und aufzugebendes Gepäck.',
                },
                // >>> ------------------------
                luggage_h5_2 : {
                    en: 'Checked Baggage',
                    de: 'Aufzugebendes Gepäck',
                },
                luggage_p_2 : {
                    en: 'The free baggage allowance for adults and minors with maximum age of 12 Years includes one piece of checked baggage up to 20 kg.<br />The free baggage allowance for minors up to 2 years includes one piece checked baggage up to 20 kg.<br /> Infant equipment (e.g. buggy or pram or cot or child car seat) is included in the free luggage allowance. A registration is not necessary.<br />Excess baggage, sport or (any kind) of special baggage can be booked online under <a href="https://www.sundair.com/services">Services</a> <b>no later than 48h prior departure</b>.<strong><br /><br />On all Beirut flights following exemptions apply:</strong><br />- 10 kg for each infant (until age 2) Additionally one (1) stroller or one (1) buggy or one (1) children’s car seat is free of charge. No pre-registration is needed.<br /><br />Book your additional baggage online until 48 hours before departure under Services.',
                    de: 'Das Freigepäck für Erwachsene und Kinder bis 12 Jahre umfasst ein aufzugebendes Gepäckstück bis maximal 20 kg.<br />Das Freigepäck für Kleinkinder bis 2 Jahre umfasst ein aufzugebendes Gepäckstück bis maximal 20 kg.<br />Kinderwagen, Buggys, Babybetten oder Autokindersitze werden innerhalb der Freigepäcksmenge für Kleinkinder (20kg) im Laderaum befördert. Eine Anmeldung ist dafür nicht notwendig.<br /><br /><strong>Auf allen Beirut – Flügen gelten folgende Ausnahmen:</strong><br />- 10 kg für ein Gepäckstück je Kleinkind (bis zum vollendeten 2. Lebensjahr)<br /><br />Zusätzlich wird ein (1) Kinderwagen oder ein (1) Buggy oder ein (1) Autokindersitz kostenfrei befördert.<br />Eine Anmeldung ist dafür nicht notwendig.<br /><br />Buchen Sie Ihr Über-, Sport- oder Sondergepäck <b>bis spätestens 48 Stunden vor Abflug</b> online unter <a href="https://www.sundair.com/services">Services.</a>',
                },
                // >>> ------------------------
                luggage_h5_3 : {
                    en: 'Carry-On Baggage ',
                    de: 'Handgepäck',
                },
                luggage_p_3 : {
                    en: 'On SUNDAIR flights only one piece of hand luggage up to <b>6kg</b> is allowed in the cabin. It shall not exceed the dimensions <b>55cm x 40cm x 20cm </b>.',
                    de: 'Auf jedem Flug dürfen Sie ein Handgepäckstück mit maximal <b>6kg</b> mit in die Kabine nehmen. Es darf die Abmessungen <b>55cm x 40cm x 20cm</b> nicht überschreiten.',
                },
                luggage_p_4 : {
                    en: 'Please observe the EU-regulations for hand luggage concerning liquids:',
                    de: 'Bitte beachten Sie die <b>EU-Handgepäckregelungen</b> für Flüssigkeiten:',
                },
                luggage_li_1 : {
                    en: 'Single container including liquids should not exceed 100ml ',
                    de: 'Einzelne Flüssigkeitsbehältnisse dürfen nicht mehr als 100ml fassen',
                },
                luggage_li_2 : {
                    en: 'A maximum of 10 containers is allowed in your hand luggage ',
                    de: 'Sie dürfen maximal 10 Behältnisse im Handgepäck transportieren',
                },
                luggage_li_3 : {
                    en: 'Liquids must be transported in a transparent, resealable plastic bag that holds no more than 1 liter',
                    de: 'Die Flüssigkeiten müssen in einem durchsichtigen, wiederverschließbaren Plastikbeutel transportiert werden, der maximal 1l fasst',
                },
                luggage_p_5 : {
                    en: 'Please take your liquids out of hand luggage and show them separately during the security control.',
                    de: 'Bitte nehmen Sie Ihre Flüssigkeiten an der Sicherheitskontrolle aus dem Handgepäck und legen Sie diese separat vor.',
                },
                // >>> ------------------------
                luggage_p_6 : {
                    en: 'In addition, the following items can be carried after prior notification, if the passenger is dependent on it:',
                    de: 'Außerdem können nach vorheriger Anmeldung folgende Gegenstände mitgenommen werden, wenn der Passagier darauf angewiesen ist:',
                },
                luggage_li_4: {
                    en: 'One Wheelchair (to be collected at the gate)',
                    de: 'ein Rollstuhl (am Gate abzugeben)',
                },
                luggage_li_5: {
                    en: 'One rollator and/or orthopedic crutches, or other prosthetic devices',
                    de: 'ein Paar Gehhilfen und/oder Schienen, sonstige Prothesen',
                },
                luggage_li_6: {
                    en: 'A guide dog (Dog trained to lead the blind/deaf)',
                    de: 'ein Blindenhund',
                },
                // >>> ------------------------
                luggage_p_7 : {
                    en: 'Please stow valuables (e.g. money, camera, laptop, keys), medicines, perishables or fragile objects in your hand luggage.',
                    de: 'Bitte verstauen Sie Ihre Wertgegenstände (z.B. Bargeld, Kamera, Laptop, Hausschlüssel), Medikamente, verderbliche oder zerbrechliche Gegenstände im Handgepäck.',
                },
                luggage_p_8 : {
                    en: 'Please observe the information about <a href="/infos-dangerous-goods/#/dangerous-goods" id="linkToDangerousGoods">"Dangerous Goods"</a>.',
                    de: 'Bitte beachten Sie unsere Informationen <a href="/infos-dangerous-goods/#/dangerous-goods" id="linkToDangerousGoods">"Gefährliche Güter"</a>.',
                },
                // >>> ------------------------
                luggage_h5_4 : {
                    en: 'Our liability regulations',
                    de: 'Unsere Haftungsbestimmungen',
                },
                luggage_p_9 : {
                    en: 'Each passenger on SUNDAIR flights is responsible for its own baggage. Make sure that the luggage and the items contained therein comply with the General Conditions of Carriage.',
                    de: 'Als Fluggast sind Sie für Ihr Gepäck verantwortlich. Stellen Sie sicher, dass Ihr Gepäckstück sowie die darin enthaltenen Gegenstände unseren Beförderungsbedingungen entsprechen. <br />Achten Sie zudem darauf, den Gepäckinhalt so zu verstauen, dass dieser keinen Schaden nimmt.',
                },
                luggage_p_10 : {
                    en: 'Please note that SUNDAIR can not be held liable for the following damages:',
                    de: 'Bitte beachten Sie, dass SUNDAIR für folgende Schäden grundsätzlich nicht haftet:',
                },
                luggage_li_7: {
                    en: 'Usual signs of wear and tear on your luggage, like dents or scratches',
                    de: 'übliche Gebrauchsspuren am Reisegepäck, wie Kratzer, Dellen oder Verschmutzungen',
                },
                luggage_li_8: {
                    en: 'Damage on incorrect packed luggage',
                    de: 'Schäden an unsachgemäß gepackten Gepäckstücken',
                },
                luggage_li_9: {
                    en: 'Damage caused by mandatory security checks',
                    de: 'Schäden, die entstanden sind, weil Art oder Inhalt des Gepäcks zu Sicherheitskontrollen geführt hat',
                },
                luggage_li_10: {
                    en: 'Valuables',
                    de: 'Wertgegenstände',
                },
                luggage_li_11: {
                    en: 'Fragile objects',
                    de: 'zerbrechliche Gegenstände',
                },
                luggage_li_12: {
                    en: 'Perishables',
                    de: 'verderbliche Güter',
                },
                luggage_li_13: {
                    en: 'Left behind hand luggage',
                    de: 'liegengelassenes Handgepäck',
                },
                luggage_p_11 : {
                    en: 'The General Terms and Conditions of Carriage apply.',
                    de: 'Es gelten unsere Allgemeinen Geschäfts- und Beförderungsbedingungen.',
                },
                // getCurrentLocale: 'de',
            };

        }, // eof data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'getCurrentLocale',
            ]),

        }, // eof computed{}
        /* <<< ****************************************************************/

    };
</script>

<style scoped>
    ul.arrow, ul.triangle, ul.circle, ul.check, ul.chevron, ul.arrow-square, ul.check-square, ul.check-circle, ul.decimal, ul.upper-roman, ul.lower-latin, ul.upper-latin {
        font-size: 1.0833em;
    }




    /* >>>  iPAD -------------------------------------------------------------*/
    @media only screen
    and (min-device-width : 768px)
    and (max-device-width : 1024px)  {
        h1 {
            font-size: 1.6em;
        }
        .booking-information {
            padding: 20px 30px 30px;
            padding-top: 20px;
            padding-right: 15px;
            padding-bottom: 30px;
            padding-left: 15px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/infos/luggage/Home.vue